import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
// Lazy load everything below the fold
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const CausesSection = lazy(() => import('./components/CausesSection').then(m => ({
  default: m.CausesSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const IngredientsSection = lazy(() => import('./components/IngredientsSection').then(m => ({
  default: m.IngredientsSection
})));
const TrustSection = lazy(() => import('./components/TrustSection').then(m => ({
  default: m.TrustSection
})));
const SocialProofSection = lazy(() => import('./components/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ReviewsSection = lazy(() => import('./components/ReviewsSection').then(m => ({
  default: m.ReviewsSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const CookieBanner = lazy(() => import('./components/CookieBanner').then(m => ({
  default: m.CookieBanner
})));
// Legal pages — rarely visited, always lazy
const ImpressumPage = lazy(() => import('./pages/ImpressumPage').then(m => ({
  default: m.ImpressumPage
})));
const DatenschutzPage = lazy(() => import('./pages/DatenschutzPage').then(m => ({
  default: m.DatenschutzPage
})));
const AGBPage = lazy(() => import('./pages/AGBPage').then(m => ({
  default: m.AGBPage
})));
const NutzungsbedingungenPage = lazy(() => import('./pages/NutzungsbedingungenPage').then(m => ({
  default: m.NutzungsbedingungenPage
})));
type Page = 'impressum' | 'datenschutz' | 'agb' | 'nutzungsbedingungen' | null;
export function App() {
  const [activePage, setActivePage] = useState<Page>(null);
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const handleNavigate = (page: Page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };
  if (activePage === 'impressum') {
    return <Suspense fallback={<div className="min-h-screen bg-white" data-id="element-1" />} data-id="element-0">
        <ImpressumPage onBack={() => handleNavigate(null)} data-id="element-2" />
      </Suspense>;
  }
  if (activePage === 'datenschutz') {
    return <Suspense fallback={<div className="min-h-screen bg-white" data-id="element-4" />} data-id="element-3">
        <DatenschutzPage onBack={() => handleNavigate(null)} data-id="element-5" />
      </Suspense>;
  }
  if (activePage === 'agb') {
    return <Suspense fallback={<div className="min-h-screen bg-white" data-id="element-7" />} data-id="element-6">
        <AGBPage onBack={() => handleNavigate(null)} data-id="element-8" />
      </Suspense>;
  }
  if (activePage === 'nutzungsbedingungen') {
    return <Suspense fallback={<div className="min-h-screen bg-white" data-id="element-10" />} data-id="element-9">
        <NutzungsbedingungenPage onBack={() => handleNavigate(null)} data-id="element-11" />
      </Suspense>;
  }
  return <main className="min-h-screen w-full bg-white text-slate-900 selection:bg-brand-100 selection:text-brand-900" data-id="element-12">
      <Header data-id="element-13" />
      <HeroSection data-id="element-14" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-16" />} data-id="element-15">
        <BenefitsSection data-id="element-17" />
        <ProblemSection data-id="element-18" />
        <CausesSection data-id="element-19" />
        <MechanismSection data-id="element-20" />
        <IngredientsSection data-id="element-21" />
        <TrustSection data-id="element-22" />
        <SocialProofSection data-id="element-23" />
        <PricingSection data-id="element-24" />
        <FAQSection data-id="element-25" />
        <ReviewsSection data-id="element-26" />
        <Footer onNavigate={page => handleNavigate(page)} onOpenCookieSettings={() => setShowCookieSettings(true)} data-id="element-27" />
        <CookieBanner onNavigateDatenschutz={() => handleNavigate('datenschutz')} forceOpen={showCookieSettings} onClose={() => setShowCookieSettings(false)} data-id="element-28" />
      </Suspense>
    </main>;
}